// DateRangeFilter — два TextField (from/to) для фильтрации событий по диапазону дат.
// Простая реализация (yyyy-MM-dd); для production можно заменить на MUI X DatePicker.
import { Stack, TextField } from '@mui/material';

export interface DateRangeValue {
  from: string;
  to: string;
}

interface DateRangeFilterProps {
  /** Текущее значение. */
  value: DateRangeValue;
  /** Колбэк при изменении. */
  onChange: (next: DateRangeValue) => void;
}

export function DateRangeFilter({ value, onChange }: DateRangeFilterProps): JSX.Element {
  function update(key: 'from' | 'to', v: string): void {
    onChange({ ...value, [key]: v });
  }

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={1.5}
      data-testid="date-range-filter"
    >
      <TextField
        type="date"
        size="small"
        label="С даты"
        value={value.from}
        onChange={(e) => update('from', e.target.value)}
        InputLabelProps={{ shrink: true }}
        inputProps={{ 'aria-label': 'Дата начала диапазона' }}
      />
      <TextField
        type="date"
        size="small"
        label="По дату"
        value={value.to}
        onChange={(e) => update('to', e.target.value)}
        InputLabelProps={{ shrink: true }}
        inputProps={{ 'aria-label': 'Дата окончания диапазона' }}
      />
    </Stack>
  );
}
